<template>
  <div class="container-fluid ">
    <div class="container" ref="lessonsList">
      <div class="row">
        <div class="col-12 text-center">
          <vue-p5 v-on="{preload, setup, draw, mousepressed}"></vue-p5>
        </div>
        <vue-nipple v-if="isTouchDevice()" ref="nippel" @dir:right="moveRight" @dir:left="moveLeft" @end="end" color="gray" mode="static"
                    :position="{left: '50%', top: '600px'}"/>

      </div>
    </div>
  </div>
</template>

<script>
import VueP5 from 'vue-p5';
import Vue from "vue";
import Nipple from 'vue-nipple';
import i18n from "@/i18n";

Vue.component('vue-nipple', Nipple)

export default {
  name: "PoliJump",
  components: {
    "vue-p5": VueP5
  },
  data: () => ({
    wideScreen: false,
    canvasWidth: 400,
    canvasHeight: 600,

    platformWidth: 85,
    platformHeight: 15,
    doodlerSize: 80,
    doodlerXSpeed: 4,
    numOfPlatforms: 4,

    doodlerX: null,
    doodlerY: null,
    doodlerVelocity: null,
    platformList: [],
    platYChange: 0,
    gameStarted: null,
    score: 0,
    highScore: 0,
    doodlerLeft: true,
    doodlerLeftImg: null,
    doodlerRightImg: null,
    platformImg: null,
    backgroundImg: null,
    bgY: 0,

    joyLeft: false,
    joyRight: false,

    fontRegular: null,
    fontBold: null,

    scoreBg: null,
    scoreBgSize: 80,

  }),
  mounted() {
    console.log("mounted")
    console.log("this.$refs.nippel", this.$refs.nippel)
  },
  methods: {
    isTouchDevice() {
      return ('ontouchstart' in window) ||
          (navigator.maxTouchPoints > 0) ||
          (navigator.msMaxTouchPoints > 0);
    },

    //joystick
    end() {
      this.joyRight = false
      this.joyLeft = false
    },
    moveLeft(event, data) {
      console.log('moveLeft', {event, data})
      this.joyRight = false
      this.joyLeft = true
      this.moveDoodler(null)
    },
    moveRight(event, data) {
      console.log('moveRight', {event, data})
      this.joyRight = true
      this.joyLeft = false
      this.moveDoodler(null)
    },

    //p5js
    preload(sk) {
      this.fontRegular = sk.loadFont(require('@/assets/hometeacher/css/font/Manrope-Light.woff'));
      this.fontBold = sk.loadFont(require('@/assets/hometeacher/css/font/Manrope-ExtraBold.woff'));

      const num = sk.random([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]);
      this.backgroundImg = sk.loadImage(require(`@/assets/games/polijump/bg_${num}.png`));
      this.platformImg = sk.loadImage(require(`@/assets/games/polijump/platform_${num}.png`));
      this.doodlerLeftImg = sk.loadImage(require(`@/assets/games/polijump/bird-${num}-left.png`));
      this.doodlerRightImg = sk.loadImage(require(`@/assets/games/polijump/bird-${num}-right.png`));
      this.scoreBg = sk.loadImage(require(`@/assets/poliglotiki/images/zerno-bg.png`));
    },
    setup(sk) {
      //sk.setAttributes('antialias', false);
      const mtply = this.wideScreen ? 2 : 1
      sk.pixelDensity(1)
      sk.createCanvas(this.canvasWidth * mtply, this.canvasHeight);
      sk.frameRate(60);
      this.gameStarted = false;

      sk.background(247, 239, 231);
      sk.image(this.backgroundImg, 0, this.bgY, this.canvasWidth, this.canvasHeight);
      if (this.wideScreen)
        sk.image(this.backgroundImg, this.canvasWidth, this.bgY, this.canvasWidth, this.canvasHeight);
    },
    draw(sk) {
      if (this.gameStarted === true) {
        //Set up and draw the game
        this.drawPlatforms(sk);
        this.drawDoodler(sk);
        this.drawScore(sk)
        this.checkCollision(sk);
        this.moveDoodler(sk);
        this.moveScreen();
      } else {
        // Start menu
        sk.fill(35, 28, 55);
        sk.stroke(255, 255, 255);
        sk.strokeWeight(4);
        sk.textAlign(sk.CENTER);
        sk.textSize(40);
        sk.textFont(this.fontRegular);
        sk.text(i18n.t('start_game'), this.canvasWidth / 2, 275);
        sk.textSize(30);
        sk.textFont(this.fontBold);
        sk.text(i18n.t('game_points') + this.score, this.canvasWidth / 2, 325);
        sk.textSize(20);
        sk.text(i18n.t('game_record') + this.highScore, this.canvasWidth / 2, 360);
        //sk.smooth()
      }
    },
    // Start Game
    mousepressed(sk) {
      if (this.gameStarted === false) {
        this.score = 0;
        this.setupPlatforms(sk);
        this.doodlerY = 350;
        this.doodlerX = this.platformList[this.platformList.length - 1].xPos + 15;
        this.doodlerVelocity = 0.1;
        this.gameStarted = true;
        this.eventStartGame()
      }
    },

    moveScreen() {
      if (this.doodlerY < 250) {
        this.platYChange = 3;
        this.doodlerVelocity += 0.25;
      } else {
        this.platYChange = 0;
      }
    },

    drawScore(sk) {
      //sk.image(this.scoreBg, this.canvasWidth - this.scoreBgSize, 0, this.scoreBgSize, this.scoreBgSize);
      sk.fill(0);
      sk.stroke(255, 205, 0);
      sk.strokeWeight(4);
      sk.textSize(20);
      sk.textFont(this.fontRegular);
      sk.textAlign(sk.CENTER);
      sk.text(this.score, this.canvasWidth - (this.scoreBgSize / 2), 40);
    },

    //  Doodler
    drawDoodler(sk) {
      sk.fill(204, 200, 52);
      sk.image(this.doodlerLeft ? this.doodlerLeftImg : this.doodlerRightImg, this.doodlerX, this.doodlerY, this.doodlerSize, this.doodlerSize);
    },

    moveDoodler(sk) {
      // doodler falls with gravity
      this.doodlerVelocity += 0.2;
      this.doodlerY += this.doodlerVelocity;

      if (sk && sk.keyIsDown(sk.LEFT_ARROW) || this.joyLeft) {
        this.doodlerX -= this.doodlerXSpeed;
        this.doodlerLeft = true
      }
      if (sk && sk.keyIsDown(sk.RIGHT_ARROW) || this.joyRight) {
        this.doodlerX += this.doodlerXSpeed;
        this.doodlerLeft = false
      }
    },

    //  Platforms
    setupPlatforms(sk) {
      const mtply = this.wideScreen ? 2 : 1
      for (var i = 0; i < this.numOfPlatforms * mtply; i++) {
        let platGap = sk.height / (this.numOfPlatforms * mtply);
        let newPlatformYPosition = i * platGap;
        let plat = {
          xPos: sk.random(15, 300 * mtply),
          yPos: newPlatformYPosition,
          width: this.platformWidth,
          height: this.platformHeight
        }; //new this.Platform(newPlatformYPosition, sk);
        this.platformList.push(plat);
      }
    },

    drawPlatforms(sk) {
      this.bgY += this.platYChange;
      if (this.bgY > this.canvasHeight)
        this.bgY = 0
      sk.image(this.backgroundImg, 0, this.bgY - this.canvasHeight, this.canvasWidth, this.canvasHeight);
      sk.image(this.backgroundImg, 0, this.bgY, this.canvasWidth, this.canvasHeight);
      if (this.wideScreen) {
        sk.image(this.backgroundImg, this.canvasWidth, this.bgY - this.canvasHeight, this.canvasWidth, this.canvasHeight);
        sk.image(this.backgroundImg, this.canvasWidth, this.bgY, this.canvasWidth, this.canvasHeight);
      }

      sk.fill(106, 186, 40);
      this.platformList.forEach((plat) => {
        // move all platforms down
        plat.yPos += this.platYChange;
        sk.image(this.platformImg, plat.xPos, plat.yPos, plat.width, plat.height);

        if (plat.yPos > this.canvasHeight) {
          this.score++;
          this.platformList.pop();
          var newPlat = {xPos: sk.random(15, 300), yPos: 0, width: this.platformWidth, height: this.platformHeight}; //new this.Platform(0, sk);
          this.platformList.unshift(newPlat); // add to front
          this.eventPoints(this.score)
        }
      });
    },

    Platform(newPlatformYPosition, sk) {
      this.xPos = sk.random(15, 300);
      this.yPos = newPlatformYPosition;
      this.width = this.platformWidth;
      this.height = this.platformHeight;
    },

    // Collisions
    checkCollision(sk) {
      this.platformList.forEach((plat) => {
        if (
            this.doodlerX < plat.xPos + plat.width &&
            this.doodlerX + this.doodlerSize > plat.xPos &&
            this.doodlerY + this.doodlerSize < plat.yPos + plat.height &&
            this.doodlerY + this.doodlerSize > plat.yPos &&
            this.doodlerVelocity > 0
        ) {
          this.doodlerVelocity = -10;
        }
      });

      if (this.doodlerY > sk.height) {
        if (this.score > this.highScore) {
          this.highScore = this.score;
        }
        this.gameStarted = false;
        this.platformList = [];
        this.eventGameOver(this.score)
      }

      // screen wraps from left to right
      if (this.doodlerX < -this.doodlerSize) {
        this.doodlerX = sk.width;
      } else if (this.doodlerX > sk.width) {
        this.doodlerX = -this.doodlerSize;
      }
    },

    eventPoints(score) {
      this.$emit('points', score)
    },

    eventStartGame() {
      this.$emit('start-game')
    },

    eventGameOver(score) {
      this.$emit('game-over', score)
    },

  },
  render(h) {
    return h(VueP5, {on: this});
  }
}
</script>

<style scoped>

</style>
